import axios from 'axios'
import moment from 'moment'

export default {
  namespaced: true,

  state: {
    beginTime: moment().startOf('day').unix(),
    endTime: moment().endOf('day').unix(),
    mediaId: undefined,
    adspotId: undefined,
    supplierId: undefined,
    isHour: true,
    reportSummary: {},

    reportDetail: [
      /*
      {
        id: 1,
        mediaId: 1,
        adspotId: 1,
        supplierId: 1,
        pvs: 1,
        bids: 1,
        requests: 1,
        succeeds: 1,
        fails: 1,
        wins: 1,
        clicks: 1,
      }
      */
    ]
  },

  getters: {
    beginTime: ({ beginTime }) => moment.unix(beginTime).format('YYYY-MM-DD'),
    endTime: ({ endTime }) => moment.unix(endTime).format('YYYY-MM-DD')
  },

  mutations: {
    changeTimeRange (state, { beginTime, endTime }) {
      state.beginTime = moment(beginTime, 'YYYY-MM-DD').startOf('day').unix()
      state.endTime = moment(endTime, 'YYYY-MM-DD').endOf('day').unix()
    },

    changeMedia (state, { mediaId }) {
      state.mediaId = mediaId
      state.adspotId = undefined
    },

    changeAdspot (state, { adspotId }) {
      state.adspotId = adspotId
    },

    changeSupplier (state, { supplierId }) {
      state.supplierId = supplierId
    },

    changeIsHour (state, { isHour }) {
      state.isHour = isHour
    },

    setReportSummary (state, { reportSummary }) {
      state.reportSummary = { ...reportSummary }
    },

    setReportDetail (state, { reportDetail }) {
      state.reportDetail = [...reportDetail]
    }
  },

  actions: {
    getReport ({ state: { beginTime, endTime, mediaId, adspotId, supplierId, isHour }, commit }) {
      const requestParams = {
        beginTime,
        endTime,
        mediaId,
        adspotId,
        supplierId,
        isDaily: !isHour
      }

      axios
        .get('/report-summary', { params: requestParams })
        .then(result => {
          commit('setReportSummary', {
            reportSummary: result.data
          })
        })

      axios
        .get('/report-table', { params: requestParams })
        .then(result => {
          commit('setReportDetail', {
            reportDetail: result.data
          })
        })
    }
  }
}
